import { useState } from 'react';
import { startOfDay } from 'date-fns';

/**
 * Returns a stable ISO timestamp for the start of the current day.
 *
 * The timestamp is calculated once when the component mounts and remains stable
 * for the component's lifetime. This ensures SWR can cache requests properly
 * without timestamp changes on every render.
 *
 * @returns ISO string timestamp for the start of the current day
 */
export const useStartOfDay = (): string => {
  const [startOfDayTimestamp] = useState(() =>
    startOfDay(new Date()).toISOString()
  );
  return startOfDayTimestamp;
};
